import { css, SerializedStyles } from '@emotion/core'

import {
  primaryDefaultBg,
  primaryDefaultBorder,
  primaryDefaultText,
  primaryHoverBg,
  primaryHoverBorder,
  subtleDefaultBg,
  subtleDefaultBorder,
  subtleDefaultText,
  subtleHoverBg,
  subtleHoverBorder,
} from '../constants/colorTokens'
import { TagColor, TagType } from '../types'

export const getColorStyle = (type: TagType, color: TagColor, clickable: boolean): SerializedStyles => {
  if (type === 'primary') {
    return css`
      background-color: ${primaryDefaultBg[color]};
      border-color: ${primaryDefaultBorder[color]};
      color: ${primaryDefaultText};

      ${clickable &&
      css`
        &:hover {
          background-color: ${primaryHoverBg[color]};
          border-color: ${primaryHoverBorder[color]};
        }
      `}
    `
  }

  return css`
    background-color: ${subtleDefaultBg[color]};
    border-color: ${subtleDefaultBorder[color]};
    color: ${subtleDefaultText[color]};

    ${clickable &&
    css`
      &:hover {
        background-color: ${subtleHoverBg[color]};
        border-color: ${subtleHoverBorder[color]};
      }
    `}
  `
}
